import React from 'react'
import styles from './DocsHeader.module.scss'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'

const DocsHeader = ({ title, onSubmit, onReset, disable }) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.buttons}>
        <div className={styles.btn}>
          <SuperButton onClick={onReset} variant='reset'>
            Reset changes
          </SuperButton>
        </div>
        <div className={styles.btn}>
          <SuperButton onClick={onSubmit} variant='confirm' disable={disable}>
            Save document
          </SuperButton>
        </div>
      </div>
    </div>
  )
}

export default DocsHeader
